/**
 * What a feature says after a no, in place of the ask (CO-D3): "Turn it on in Settings", a link to
 * Settings › Privacy. It informs and never asks: the agreement is given on the Privacy tab
 * (`ReadAndAgree` in `PrivacyTab`), the one way back, as Strava keeps its health-data choice in Settings.
 * The coach page's strip and the dashboard's note draw it, so the two cannot drift apart in words or in
 * where they lead.
 *
 * A text link in the accent, not a pill: a pill read as an answer button, and this is a way to a page.
 * 44 px high, so it is a full press area wherever it sits.
 */

import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'

import { COPY } from '../../copy/firstRun'
import { FOCUS_RING } from '../ui/focusRing'

/** Where the link goes: Settings opens on its Privacy tab when the address names it. */
export const SETTINGS_PRIVACY_PATH = '/settings?tab=privacy'

export function SettingsPrivacyLink({ className = '' }: { className?: string }) {
  return (
    <Link
      to={SETTINGS_PRIVACY_PATH}
      className={`inline-flex min-h-11 shrink-0 items-center gap-1 whitespace-nowrap rounded-full text-sm font-medium text-(--accent-amber) transition-colors duration-150 hover:text-(--accent-amber-light) ${FOCUS_RING} ${className}`}
    >
      {COPY.consentOffSettings}
      <ChevronRight className="h-3.5 w-3.5" aria-hidden />
    </Link>
  )
}
